var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightOutlineinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 73.907 58.853"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Trazado 928",
    d: "M0 58.85a6.394 6.394 0 004.522-1.874L60.234 1.25a4.263 4.263 0 017.278 3.015v48.19a6.4 6.4 0 006.395 6.4z",
    fill: "currentColor"
  })));
}

export default SvgRightOutlineinline;